export enum FundingsLocators {
	createNewFundingButton = 'createNewFundingButton',
	editFundingButton = 'editFundingButton',
	cancelFundingButton = 'cancelFundingButton',
	cancelCancelFundingButton = 'cancelCancelFundingButton',
	confirmCancelFundingButton = 'confirmCancelFundingButton',
}
